import React, { useEffect, useRef } from 'react';
import { ArrowLeft, Building2 } from 'lucide-react';

const PROVIDER_LABELS = { microsoft: 'Microsoft', google: 'Google', oidc: 'organisation SSO' };

const SsoStep = ({ email, organisation, provider, error, busy, onContinue, onUsePassword, onBack }) => {
  const headingRef = useRef(null);
  useEffect(() => headingRef.current?.focus(), []);
  const providerLabel = PROVIDER_LABELS[provider] || 'organisation SSO';

  return (
    <div className="enterprise-auth-step">
      <p className="enterprise-auth-kicker">Organisation sign-in</p>
      <h2 ref={headingRef} tabIndex="-1">Continue securely</h2>
      <div className="enterprise-auth-sso-card">
        <span className="enterprise-auth-sso-icon" aria-hidden="true"><Building2 size={22}/></span>
        <div><strong>{organisation?.name || 'Your organisation'}</strong><p>{email}</p></div>
      </div>
      <p className="enterprise-auth-intro">Your organisation uses {providerLabel} for account access.</p>
      {error && <p className="enterprise-auth-error" role="alert">{error}</p>}
      <button className="enterprise-auth-primary" type="button" aria-busy={busy} onClick={onContinue}>{busy ? 'Opening secure sign-in…' : `Continue with ${providerLabel}`}</button>
      {onUsePassword && <button type="button" className="enterprise-auth-link-button enterprise-auth-sso-password" onClick={onUsePassword}>Sign in with a password instead</button>}
      <button type="button" className="enterprise-auth-back" onClick={onBack}><ArrowLeft size={16}/>Use another email</button>
    </div>
  );
};

export default SsoStep;
